__turbopack_context__.v({
  "chatSpecialist": "BottomBar-module__LM1bmq__chatSpecialist",
  "ctaStack": "BottomBar-module__LM1bmq__ctaStack",
  "midPanel": "BottomBar-module__LM1bmq__midPanel",
  "midPanelPhone": "BottomBar-module__LM1bmq__midPanelPhone",
  "midPanelPhonePrice": "BottomBar-module__LM1bmq__midPanelPhonePrice",
  "midPanelPhoneRight": "BottomBar-module__LM1bmq__midPanelPhoneRight",
  "midPanelPhoneRow": "BottomBar-module__LM1bmq__midPanelPhoneRow",
  "offerIcon": "BottomBar-module__LM1bmq__offerIcon",
  "offerIcons": "BottomBar-module__LM1bmq__offerIcons",
  "root": "BottomBar-module__LM1bmq__root",
  "subtitleTextBtn": "BottomBar-module__LM1bmq__subtitleTextBtn",
  "taxDisclaimer": "BottomBar-module__LM1bmq__taxDisclaimer",
  "totalPriceSingle": "BottomBar-module__LM1bmq__totalPriceSingle",
  "tradeInCredit": "BottomBar-module__LM1bmq__tradeInCredit",
});
